// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n[dir] .b-card[data-v-1c3b0796] {\r\n  border-radius: 10px;\r\n  box-shadow: 0px 0px 15px rgba(0, 0, 0, 0.1);\n}\r\n", ""]);
// Exports
module.exports = exports;
